export default __webpack_public_path__ + "static/media/sunsculpted7.f874d959.jpg";